// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Bbde6","nav":"Header_nav__0Ci-Y","navLinks":"Header_navLinks__HYtYD","navLink":"Header_navLink__xchuC","activeLink":"Header_activeLink__+iWz5"};